import { render, staticRenderFns } from "./ProductChangeDescription.vue?vue&type=template&id=19225ad9"
import script from "./ProductChangeDescription.vue?vue&type=script&lang=js"
export * from "./ProductChangeDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports